/**
 * 域名容灾模块提供两个方法
 *
 * 1. isFailOverModel 判断当前环境是否为容灾模式
 * 2. getFailOverUrl 获取可用的链接
 *
 * @example
 * ```javascript
 * import { isFailOverModel, getFailOverUrl } from '@kibt/web-utils/fail-over'
 * ```
 *
 * 目前已内置以下主备域名映射，若需要替换的域名内不在列表中，需要SRE（李隆）确认是否存在备用域名并主动替换
 *
 * | 主域名 | 备用域名 |
 * |:-----:|:-------:|
 * | m.kwai.com | m.kslawin.com |
 * | incentive.kwai.com | incentive.kslawin.com |
 * | app.kwai.com | app.kslawin.com |
 * | m-wallet.kwai.com | m-wallet.kslawin.com |
 * | m-live.kwai.com | m-live.kslawin.com |
 * | m-creative.kwai.com | m-creative.kslawin.com |
 * | m-shop.kwai.com | m-shop.kslawin.com |
 * | shop.kwai.com | shop.kslawin.com |
 * | www.kwai.com | www.kslawin.com |
 * | hotvideo.kwai.com | hotvideo.kslawin.com |
 * | share.kwai.com | share.kslawin.com |
 *
 * @packageDocumentation
 */
var serviceDomainMap = {
  'm.kwai.com': 'm.kslawin.com',
  'incentive.kwai.com': 'incentive.kslawin.com',
  'app.kwai.com': 'app.kslawin.com',
  'm-wallet.kwai.com': 'm-wallet.kslawin.com',
  'm-live.kwai.com': 'm-live.kslawin.com',
  'm-creative.kwai.com': 'm-creative.kslawin.com',
  'm-shop.kwai.com': 'm-shop.kslawin.com',
  'shop.kwai.com': 'shop.kslawin.com',
  'www.kwai.com': 'www.kslawin.com',
  'hotvideo.kwai.com': 'hotvideo.kslawin.com',
  'share.kwai.com': 'share.kslawin.com'
};
/**
 * 当前是否处于容灾模式，可基于该结果进行自定义域名替换处理
 */

export var isFailOverModel = function isFailOverModel() {
  var ua = window.navigator.userAgent || '';
  return /ISDR\/1/.test(ua);
};
/**
 * 获取安全可用的链接，容灾模式下会替换成备用域名
 * @param {string} url 链接
 * @returns {string}
 *
 * @example
 * 使用方式
 *
 * ```javascript
 * import { isFailOverModel, getFailOverUrl } from '@kibt/web-utils/fail-over'
 *
 * const url = getFailOverUrl('https://m-wallet.kwai.com/wallet');
 *
 * ```
 */

export var getFailOverUrl = function getFailOverUrl(url) {
  if (!url) {
    return url;
  }

  if (!isFailOverModel()) {
    return url;
  }

  try {
    var urlInstance = new URL(url); // 不存在DOMAIN 或者 备用域名未配置时 返回原链接

    if (!urlInstance.host || !serviceDomainMap[urlInstance.host]) {
      return url;
    }

    return url.replace(urlInstance.host, serviceDomainMap[urlInstance.host]);
  } catch (_unused) {
    return url;
  }
};